export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;
//# sourceMappingURL=keyboard.js.map